import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

// ksm_frontend ApprovalV2ActionDialog.js 포팅(2026-10-20) - 승인/반려 의견 입력 다이얼로그.
// 반려는 의견을 필수로 요구한다(approval_v2_ux.md "rejection requires comment").
const ApprovalV2ActionDialog = ({ open, action, docTitle, onClose, onConfirm }) => {
  const [comment, setComment] = useState('');
  const isReject = action === 'reject';

  const handleClose = () => {
    setComment('');
    onClose();
  };

  const handleConfirm = () => {
    if (isReject && !comment.trim()) {
      return;
    }
    onConfirm(comment);
    setComment('');
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isReject ? '결재 반려' : action === 'recall' ? '결재 회수' : '결재 승인'}</DialogTitle>
      <DialogContent>
        {docTitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {docTitle}
          </Typography>
        )}
        {action !== 'recall' && (
          <TextField
            fullWidth
            multiline
            minRows={3}
            label={isReject ? '반려 의견(필수)' : '의견(선택)'}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            error={isReject && !comment.trim()}
            helperText={isReject && !comment.trim() ? '반려 사유를 입력하세요.' : ''}
          />
        )}
        {action === 'recall' && (
          <Typography variant="body2">이 문서를 회수하시겠습니까? 진행 중인 결재 단계가 모두 취소됩니다.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          취소
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color={isReject ? 'error' : 'primary'}
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalV2ActionDialog;
